import axios from 'axios'
import { api } from './api'
import { postFetch } from './request'
import { Random } from 'xhwebtool'
import { RSSign } from './sign'
import QueryString from 'qs'
const GAME_CENTER_KEY = 'qrUFZHU0bw7oOzZ6zL1p'
const commonModel = {
  // 初始化接口
  init: async (Data) => {
    const success = await postFetch(api.init, Data)
    return success
  },
  // 获取服务器时间
  time: async (Data) => {
    const success = await postFetch(api.time, Data)
    return success
  },
  // 发送短信
  send: async (Data) => {
    const success = await postFetch(api.send, Data)
    return success
  },
  // 预约状态查询
  checkState: async (Data) => {
    const success = await postFetch(api.checkState, Data)
    return success
  },
  // 预约
  reserve: async (Data) => {
    const success = await postFetch(api.reserve, Data)
    return success
  },
  // 获取文章列表
  articles: async (Data) => {
    const success = await postFetch(api.articles, Data)
    return success
  },
  // 获取文章详情
  details: async (Data) => {
    const success = await postFetch(api.details, Data)
    return success
  },
  // 获取文章列表(含子栏目)
  articlesSubList: async (Data) => {
    const success = await postFetch(api.articlesSubList, Data)
    return success
  },
  // 获取文章扩展内容
  additicont: async (Data) => {
    const success = await postFetch(api.additicont, Data)
    return success
  },
  // 获取栏目列表
  columns: async (Data) => {
    const success = await postFetch(api.columns, Data)
    return success
  },
  // 获取栏目扩展字段
  additi: async (Data) => {
    const success = await postFetch(api.additi, Data)
    return success
  },
  // 微信分享
  share: async (Data) => {
    const success = await postFetch(api.share, Data)
    return success
  },
  // 获取小程序链接
  wxUrl: async (Data) => {
    const success = await postFetch(api.wxUrl, Data)
    return success
  },
  // 预约里程碑
  milestone: async (Data) => {
    const success = await postFetch(api.milestone, Data)
    return success
  },
  // 预约里程碑
  wxQrcode: async (Data) => {
    const success = await postFetch(api.wxQrcode, Data)
    return success
  },
  // 登出
  logout: async () => {
    const success = await axios.get(api.logout)
    return success
  },
  // 创建请求头
  createHeader: async function (key) {
    let header = {
      pf_source: 'miniprogram-community',
      version: '1.0.0',
      nonce: Random.randomString(),
      ts: await this.getGameCenterCurrentTime(),
    }
    header.sign = RSSign(header, key)
    return btoa(QueryString.stringify(header))
  },
  /**
   * 获取主站服务器时间
   */
  getGameCenterCurrentTime: (() => {
    const timeDiffPromise = new Promise((resolve) => {
      let retryTimes = 0
      const get = () => {
        if (retryTimes++ > 3) return
        const params = {
          ts: Date.now(),
          nonce: Random.randomString(),
          version: '1.1',
          sign_type: 'md5',
        }
        params.sign = RSSign(params, GAME_CENTER_KEY)
        axios({
          method: 'get',
          params,
          url: api.gameCenterTime,
        })
          .then((res) => {
            if (!res.data?.data?.server_time_ms) throw new Error()
            resolve(Date.now() - res.data.data.server_time_ms)
          })
          .catch(() => {
            setTimeout(get, retryTimes * 1000)
          })
      }
      get()
    })
    return async () => {
      const diff = await timeDiffPromise
      return Date.now() - diff
    }
  })(),
  // 角色列表
  async getRoleList(app_id, cch_id, game_type, activityTag) {
    const params = {
      ts: await this.getGameCenterCurrentTime(),
      nonce: Random.randomString(),
      version: '1.0.0',
      sign_type: 'md5',
      app_id,
      cch_id,
      game_type,
    }

    params.sign = RSSign(params, GAME_CENTER_KEY)
    return axios({
      method: 'get',
      url: api.roleList,
      params,
      activityTag,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Client-Biz-Info': await this.createHeader(GAME_CENTER_KEY),
      },
    })
  },
}
export default commonModel
